module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.internalView) ? _c('v-layout', {
    staticClass: "mb-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "12",
      "md": "6"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignData.min_content) + " to " + _vm._s(_vm.campaignData.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + "%")])])], 1)]
      }
    }], null, false, 1347022726)
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "12",
      "md": "6"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }], null, false, 3245034452)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.internalView) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "pairing-elimination-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.influencerItems,
      "items-per-page": _vm.itemsPerPage,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.name
          }, [(_vm.displayFields('igHandle')) ? _c('td', {
            class: {
              'table-row-eliminated': _vm.isEliminated(item)
            }
          }, [_c('social-handle', {
            attrs: {
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isYoutube": item.platform === 'youtube',
              "isFacebook": item.platform === 'facebook',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isLinkedIn": item.platform === 'linkedin',
              "isTwitter": item.platform === 'twitter' || item.platform === 'x',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle,
              "linkedinHandle": item.linkedinHandle || item.userHandle || item.instagramHandle,
              "twitterHandle": item.twitterHandle || item.userHandle || item.instagramHandle,
              "otherHandle": item.instagramHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('platformName')) ? _c('td', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('totalFollowers')) ? _c('td', {
            class: {
              'table-row-eliminated': _vm.isEliminated(item)
            }
          }, [(item.followers) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.followers)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "max-width": "70px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + (item.pairingID)),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": _vm.getGenderPieData(item.audience_genders),
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('AudienceCredibility')) ? _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagementRate')) ? _c('td', [(item.engagement_rate) ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + " %")]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.displayFields('remarks')) ? _c('td', [_vm._v(_vm._s(item.remarks))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('contentFeature')) ? _c('td', [_vm._v(_vm._s(item.contentFeature))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            class: ("ma-2 " + (_vm.isEliminated(item) ? 'eliminate-text': '')),
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('age_group')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            class: ("ma-2 " + (_vm.isEliminated(item) ? 'eliminate-text': '')),
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('aud_age_group')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l((item.topAudAges), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "ml-2"
            }, [_c('v-chip', {
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))])], 1)
          }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l((item.topCountries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "ml-2"
            }, [_c('v-chip', {
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))])], 1)
          }), 0)]) : _vm._e(), _vm._v(" "), (_vm.elimination && _vm.displayFields('selected')) ? _c('td', [_c('v-menu', {
            attrs: {
              "offset-y": "",
              "disabled": _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  class: _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED ? 'v-btn--disabled v-btn--has-bg' : '',
                  attrs: {
                    "color": _vm.getSelectAttributes(item, 'color'),
                    "dense": "",
                    "dark": _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED ? false : true
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "left": ""
                  }
                }, [_vm._v("\n                    " + _vm._s(_vm.getSelectAttributes(item, 'icon')) + "\n                  ")]), _vm._v(" " + _vm._s(_vm.getSelectAttributes(item, 'text')) + "\n                ")], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.getSelectAttributes(item, 'menus')), function(action, actionIndex) {
            return _c('v-list-item', {
              key: actionIndex,
              on: {
                "click": function($event) {
                  return _vm.actionHandler(item.pairingID, action.title)
                }
              }
            }, [_c('v-list-item-title', [_c('v-icon', {
              attrs: {
                "left": ""
              }
            }, [_vm._v("\n                    " + _vm._s(_vm.getIconByTitle(action.title)) + "\n                  ")]), _vm._v(" " + _vm._s(action.title))], 1)], 1)
          }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('eliminatedReason')) ? _c('td', [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.isEliminated(item)),
                    expression: "isEliminated(item)"
                  }],
                  attrs: {
                    "small": ""
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewReason(item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-file-document-box")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Reason")])])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('notes')) ? _c('td', [(!_vm.isClientRole && item.clientNotes.length) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "small": "",
                    "color": "warning"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.openClientNotesDialog(item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-file-document-box")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Note")])]) : _vm._e(), _vm._v(" "), (_vm.isClientRole) ? _c('v-badge', {
            attrs: {
              "value": _vm.getClientUnreadCount(item),
              "content": _vm.getClientUnreadCount(item),
              "color": "green",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openClientNotesDialog(item)
              }
            }
          }, [_c('v-btn', {
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openClientNotesDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Add Note (" + _vm._s(item.clientNotes ? item.clientNotes.length : 0) + ")\n              ")], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.elimination && _vm.displayFields('selected')) ? _c('td', [_vm._v("\n            " + _vm._s(_vm.showEliminationStatus(item.eliminationStatus)) + "\n            "), _c('v-icon', {
            attrs: {
              "right": "",
              "color": _vm.isSelected(item) ? 'green' : 'red'
            }
          }, [_vm._v(_vm._s(_vm.isSelected(item) ? 'check' : 'cancel'))])], 1) : _vm._e()])
        }), 0)]
      }
    }])
  }), _vm._v(" "), (_vm.elimination && !_vm.internalView) ? _c('div', {
    staticClass: "text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('accept')
      }
    }
  }, [_vm._v("Accept All")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('save_draft')
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('save')
      }
    }
  }, [_vm._v("Save and Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.internalView) ? _c('div', {
    staticClass: "pairing-elimination-actions text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.closeElimination
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmSendToClient()
      }
    }
  }, [_vm._v("Confirm")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "480"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Share with us why this influencer is eliminated\n        "), _c('span', [_vm._v("(note to avoid subjective bias)")])]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.eliminatedReason),
      callback: function($$v) {
        _vm.eliminatedReason = $$v
      },
      expression: "eliminatedReason"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.cancelReason
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.saveReason
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.viewReasonDialog),
      callback: function($$v) {
        _vm.viewReasonDialog = $$v
      },
      expression: "viewReasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Remarks for \n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://instagram.com/' + _vm.viewReasonData.igHandle
    }
  }, [_vm._v("@" + _vm._s(_vm.viewReasonData.igHandle))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "body-1"
  }, [_vm._v(_vm._s(_vm.viewReasonData.text))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewReasonDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('client-notes-modal', {
    attrs: {
      "value": _vm.clientNotesDialog,
      "data": _vm.clientNotesData
    },
    on: {
      "savedNotes": _vm.refreshPairingData
    },
    model: {
      value: (_vm.clientNotesDialog),
      callback: function($$v) {
        _vm.clientNotesDialog = $$v
      },
      expression: "clientNotesDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Client Elimination Columns",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0845a826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/PairingDataTable.vue
// module id = 1989
// module chunks = 0